export default "__VITE_ASSET__DGCIiQbr__"